import type { FieldRendererProps } from '../../config/types';
import { Checkbox } from '@/components/ui/Checkbox';
import { Switch } from '@/components/ui/Switch';
import { Text } from '@/components/ui/Text';

export function CheckboxRenderer({ field, value, onChange, onBlur }: FieldRendererProps) {
  // `props.variant: 'switch'` draws the same boolean as an on/off switch (ENT-565: the proposal
  // wizard's toggles). Default is unchanged: a checkbox with its label beside it.
  if (field.props?.variant === 'switch') {
    return (
      <div className="flex items-center gap-2">
        <Switch
          id={field.id}
          checked={value === true}
          onCheckedChange={(checked) => onChange(checked === true)}
          disabled={field.isDisabled}
          aria-label={field.label}
        />
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id={field.id}
        checked={!!value}
        onCheckedChange={(checked) => onChange(!!checked)}
        onBlur={onBlur}
        disabled={field.isDisabled}
      />
      {field.label && (
        <label htmlFor={field.id}>
          <Text variant="body-sm">{field.label}</Text>
        </label>
      )}
    </div>
  );
}
